import { mixin as clickaway } from 'vue-clickaway'

export default {
    name: 'InputDropdown',
    mixins: [ clickaway ],

    data() {
        return {
            dropdownClass: 'input-dropdown-hidden',
            error: '',
            selectedValue: ''
        }
    },

    props: {
        label: String,
        required: Boolean,
        placeholder: String,
        value: [String, Number],
        data: Array,
        disabled: Boolean,
        extension: String
    },

    methods: {
        showItems() {
            this.dropdownClass = this.disabled ? 'input-dropdown-hidden' : ''
        },

        hideItems() {
            this.dropdownClass = 'input-dropdown-hidden'
        },

        selectItem(index) {
            this.selectedValue = this.data[index].value
            this.$emit('change', this.data[index].id)
            this.hideItems()
            this.checkForError()
        },

        checkForError() {
            this.error = (this.value != '' && this.value != undefined) || this.selectedValue != '' || !this.required ? '' : 'input-dropdown-error'
            return this.error
        },

        reset() {
            this.selectedValue = ''
        }
    }
}